
export interface AmountVerifyResponse {
  actualAmount?: number;
  isValid: boolean;
  message?: string;
  success: boolean;
}
